
import { useEffect, useState } from "react";

const API_PATH = "/api/streamlit/";
const STATUS_PATH = "/api/streamlit-status";

export default function TrafficSignalPage() {
  const [status, setStatus] = useState("loading");
  const [attempt, setAttempt] = useState(0);

  useEffect(() => {
    let cancelled = false;

    async function checkSimulation() {
      try {
        // This request starts Streamlit if it is not running.
        const response = await fetch(API_PATH, {
          credentials: "same-origin",
        });

        if (!response.ok) {
          throw new Error("Simulation server unavailable");
        }

        const health = await fetch(STATUS_PATH);

        if (!health.ok) {
          throw new Error("Health check failed");
        }

        const data = await health.json();

        if (!cancelled) {
          setStatus(data.ready ? "ready" : "error");
        }
      } catch (error) {
        console.error("Traffic simulation:", error);

        if (!cancelled) {
          setStatus("error");
        }
      }
    }

    checkSimulation();

    return () => {
      cancelled = true;
    };
  }, [attempt]);

  function retry() {
    setStatus("loading");
    setAttempt((previous) => previous + 1);
  }

  const containerStyle = {
    position: "fixed",
    inset: 0,
    width: "100vw",
    height: "100vh",
    background: "#0e1117",
    color: "#ffffff",
    overflow: "hidden",
    fontFamily: "Inter, Arial, sans-serif",
  };

  const centerStyle = {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    gap: "16px",
    textAlign: "center",
    padding: "24px",
    boxSizing: "border-box",
  };

  return (
    <div style={containerStyle}>
      {status === "loading" && (
        <div style={centerStyle}>
          <div style={{ fontSize: "48px" }}>🚦</div>
          <h2>Setting up traffic simulation</h2>
          <p style={{ color: "#94a3b8" }}>
            Starting the simulation engine.
            This may take a few seconds.
          </p>
          <div
            style={{
              width: "32px",
              height: "32px",
              border: "3px solid #334155",
              borderTopColor: "#60a5fa",
              borderRadius: "50%",
              animation: "trafficSpin 0.8s linear infinite",
            }}
          />
          <style>
            {`
              @keyframes trafficSpin {
                to { transform: rotate(360deg); }
              }
            `}
          </style>
        </div>
      )}

      {status === "error" && (
        <div style={centerStyle}>
          <div style={{ fontSize: "48px" }}>⚠️</div>
          <h2>Simulation unavailable</h2>
          <p style={{ color: "#94a3b8" }}>
            The simulation engine could not start.
            Please try again.
          </p>
          <button
            onClick={retry}
            style={{
              padding: "12px 28px",
              background: "#315fea",
              color: "#ffffff",
              border: "none",
              borderRadius: "10px",
              cursor: "pointer",
              fontWeight: 600,
            }}
          >
            Retry Simulation
          </button>
        </div>
      )}

      {status === "ready" && (
        <iframe
          key={attempt}
          src={API_PATH}
          title="AI Traffic Flow Simulation"
          data-testid="traffic-signal-iframe"
          style={{
            width: "100%",
            height: "100%",
            border: "none",
            display: "block",
          }}
        />
      )}
    </div>
  );
}
